<style>

    main{
        direction: rtl;
    }

    label:not(.btn,.form-check-label) {
        background-color: white;
        position: relative;
        right: 10px;
        top: 13px;
        padding: 0 10px;
        font-size: 14px;
        z-index: 2;
    }

    .form-control,
    .form-select {

        padding-top: 10px;

        background-color: white !important;

    }

    .list-group-item {

        background: rgba(128, 128, 128, 0.507) !important;

        border: 1px solid white !important;

        color: black !important;
    }

    .list-group-item:hover {
        opacity: 0.9;
    }

    div:has(>.fa-chevron-down) {

        position: relative;

    }

    .fa-chevron-down {
        position: absolute;
        left: 12px;
        top: 45px;
    }

    div.position-relative>label {
        background-color: white;
        position: absolute;
        right: 17px;
        top: -2px;
        padding: 0 10px;
        font-size: 14px;
        z-index: 2;
    }

    div.position-relative>input,
    div.position-relative>select {
        color: navy;

    }

    div.position-relative>input:disabled {

        background-color: white !important;

    }
    
</style>

<!-- هدر فرم -->

<div class="bg-th-blue mt-0 container-fluid py-2 position-sticky top-0" style="z-index: 100;">

    <div class=" d-flex justify-content-between align-content-center">

        <i class="fa fa-arrow-left text-white my-auto pointer" (click)="goBack()"></i>

        <a class="text-white f18 my-auto dirI d-flex align-items-center"> 

            {{ 
                
                Id == 1 ? 'ثبت خودرو با ردیاب' :
                
                Id == 2 ? 'ثبت خودرو بدون ردیاب' :
                
                Id == 3 ? 'ثبت خودرو اداری' : ''
            
            }}
            
            <i class="fa fa-question-circle fa-2x pointer ms-2" (click)="guid()"></i>
        
        </a>

    </div>

</div>

<!-- فرم ثبت خودرو -->

<main class="container rounded p-2 mt-3">

    <!-- ثبت خودرو با ردیاب -->

    <!-- ثبت خودرو اداری -->

    <div *ngIf="Id == 1 || Id == 3" [formGroup]="sabtModelGps" class="container-fluid row gx-2 gy-md-1 gy-2 p-2">

        <!-- این فیلد مربوط به خودروهای اداری می باشد -->

        <ng-container *ngIf="Id == 3">

            <div class="col-12 d-flex justify-content-center my-3">

                <div class="d-flex align-items-end col-md-6 col-12" (click)="off()">
            
                    <div class="w-100 btn-group" role="group">
        
                        <input type="radio" class="btn-check" 
                        
                            name="gpsStatus" id="btnradio1" autocomplete="off" checked
    
                            (click)="generateUnitId(false)">
    
                        <label class="btn btn-outline-success" for="btnradio1"> تحت ردیاب </label>
        
                        <input type="radio" class="btn-check"
                        
                            name="gpsStatus" id="btnradio2" autocomplete="off"
    
                            (click)="generateUnitId(true)">
    
                        <label class="btn btn-outline-secondary" for="btnradio2"> بدون ردیاب </label>
        
                    </div>
        
                </div>
            
            </div>

        </ng-container>

        <!-- شناسه دستگاه -->

        <div class="position-relative col-md-4 p-2" [ngClass]="imeIInp ? 'col-12' : 'col-7' ">

            <label class="mb-2 text-muted"> شناسه دستگاه </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                id="Imei" [readonly]="imeIInp" formControlName="strUnitId">

        </div>

        <!-- بررسی شناسه -->

        <ng-container *ngIf="!imeIInp">

            <div class="position-relative col-auto p-2">

                <button (click)="Imei()" class="btn btn-primary w-100 h-100"> 
    
                    بررسی شناسه                
                
                </button>
                
            </div>

        </ng-container>

        <!-- نوع کاربری -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع کاربری </label>

            <select class="form-select" formControlName="tiMobileUsage">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_MobileUsage" value="{{item.tiMobileUsage}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>
        
        <!-- نوع خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع خودرو </label>

            <select class="form-select" formControlName="tiMobileType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of carWork" value="{{item.tiMobileType}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- گروه خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> گروه خودرو </label>

            <select class="form-select" formControlName="tiMobileGroup">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_GroupCar" value="{{item.tiMobileGroup}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- نام خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نام خودرو </label>

            <input type="text"

                [placeholder]="carType.length == 0 && searchT_CarName == '' ?
                
                ' لطفا اندکی صبر کنید ' : 'جستجو کنید ...'  "

                name="selectedCarName" autocomplete="off" class="form-control text-center"
                
                (focus)="filteredCarName = carType"

                [(ngModel)]="searchT_CarName" 
                
                [ngModelOptions]="{standalone: true}" (input)="filterCarName()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" 
                
                *ngFor="let item of filteredCarName" [@fadeAnimation]

                    (click)="selectedCarName(item)"> {{item.strComment }}
                
                </li>

            </ul>

        </div>

        <!-- تیپ خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> تیپ خودرو </label>

            <input class="form-control p-2 text-center" formControlName="strVehicleType">

        </div>

        <!-- کد خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> کد خودرو </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="iCode">

        </div>
        
        <!-- ظرفیت خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> ظرفیت خودرو </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="tiPassenger">

        </div>
        
        <!-- نوع سوخت -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع سوخت </label>

            <select class="form-select" formControlName="tiFuelType">

                <option class="text-center" [value]="0"> ندارد</option>

                <option class="text-center" [value]="1"> بنزین </option>

                <option class="text-center" [value]="2"> نفت گاز </option>

                <option class="text-center" [value]="3"> هیبرید </option>

                <option class="text-center" [value]="4"> برقی </option>

            </select>

        </div>
                
        <!-- ظرفیت باک (لیتر)  -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> ظرفیت باک (لیتر)  </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{1}).*$/, '$1');"

                formControlName="fFuelTankCapacity">

        </div>

        <!-- نوع ردیاب -->
        
        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع ردیاب </label>

            <input type="text"

                [placeholder]="gpsType.length == 0 && searchT_Gps == '' ?
                
                ' لطفا اندکی صبر کنید ' : 'جستجو کنید ...'  "

                name="selectedGps" autocomplete="off" class="form-control text-center"
                
                (focus)="filteredGps = gpsType" id="gpsInput"

                [(ngModel)]="searchT_Gps" 
                
                [ngModelOptions]="{standalone: true}" (input)="filterGps()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer"
                
                *ngFor="let item of filteredGps" [@fadeAnimation]
                
                    (click)="selectedGps(item)"> {{item.strComment}} 
                
                </li>

            </ul>

        </div>

        <!-- آیکون خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> آیکون خودرو </label>

            <input type="text"

                [placeholder]="carImg.length == 0 && searchT_CarIcon == '' ?
                
                ' لطفا اندکی صبر کنید ' : 'جستجو کنید ...'  "

                name="selectedCarIcon" autocomplete="off" class="form-control text-center"
                
                (focus)="filteredCarIcon = carImg"


                [(ngModel)]="searchT_CarIcon"
                
                [ngModelOptions]="{standalone: true}" (input)="filterCarIcon()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" 
                
                *ngFor="let item of filteredCarIcon" [@fadeAnimation]

                    (click)="selectedCarIcon(item,item.tiMobileIcon)"> 
                    
                    <img src="data:image/jpeg;base64,{{item.strMobileIcon}}">
                    
                    {{item.strComment}} 
                
                </li>

            </ul>

        </div>

        <!-- نام و نام خانوادگی رانند ه -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> نام و نام خانوادگی راننده </label>

            <input class="form-control p-2 text-center" formControlName="strFullName">

        </div>

        <!-- کیلومتر فعلی خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> کیلومتر فعلی خودرو </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="fLastKM">

        </div>

        <!-- موبایل راننده -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> موبایل راننده </label>

            <input class="form-control p-2 text-center"

                maxlength="11"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="strMobile">

        </div>
        
        <!-- حداکثر سرعت مجاز -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> حداکثر سرعت مجاز </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="tiMaxSpeed" (keypress)="checkNum($event)">

        </div>

        <!-- شماره سیمکارت ردیاب -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> شماره سیمکارت ردیاب </label>

            <input class="form-control p-2 text-center" maxlength="11"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="strCellNo" (keypress)="checkNum($event)">

        </div>

        <!-- رمز عبور دستگاه -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> رمز عبور دستگاه </label>

            <input type="text" class="form-control text-center"  formControlName="strPassword">
            
        </div>

        <!-- رنگ خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> رنگ خودرو </label>

            <input type="text" class="form-control text-center"  formControlName="strColor">

        </div>

        <!-- vin خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> VIN خودرو </label>

            <input type="text" class="form-control text-center"  formControlName="strVIN">

        </div>

        <!-- سال ساخت -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> سال ساخت </label>

            <input type="text" class="form-control text-center"  formControlName="iYearConstruction">

        </div>

        <!-- مصرف سوخت شهری -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> مصرف سوخت شهری(L/100) </label>

            <input type="text" class="form-control text-center"  formControlName="fGasPer100" >

        </div>

        <!-- مصرف سوخت درجا -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> مصرف سوخت درجا(L/H) </label>

            <input type="text" class="form-control text-center"  formControlName="fGasPer100_Tr">

        </div>

        <!-- توان خودرو(HP) -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> توان خودرو(HP) </label>

            <input type="text" class="form-control text-center"  formControlName="fGasPer100_HW">

        </div>

        <!-- ولتاژ روشن -->
        <div class="position-relative col-12 col-md-4 p-2">
            <label class="mb-2 text-muted"> ولتاژ روشن </label>
            <input type="text" class="form-control text-center"  formControlName="fMinVoltage">
            <div class="icon-wrapper">
                <button class="btn btn-info" (click)="analyzeVoltage()" >
                    <i class="fa fa-calculator" title="تحلیل ولتاژ روشن"></i>
                </button>
            </div>
        </div>
        <!-- کد تقسیمات کشوری  -->
        <div class="position-relative col-12 col-md-4 p-2">
            <label class="mb-2 text-muted"> کد تقسیمات کشوری  </label>
            <input type="text" class="form-control text-end"  formControlName="strProvinceCode" maxlength="15">
        </div>

        <!-- تاریخ ثبت -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label> تاریخ ثبت </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strDefinationDate" class="form-control text-center" />

            </ng-persian-datepicker>

        </div>

        <!-- تاریخ پایان اعتبار -->

        <div *ngIf="carId && acssess.bEditExpiredDate" class="position-relative col-12 col-md-4 p-2">

            <label> تاریخ پایان اعتبار </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strValidDate" class="form-control text-center" />

            </ng-persian-datepicker>

        </div>

        <!-- شماره پرسنلی -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> شماره پرسنلی </label>

            <input type="text" class="form-control text-center"  formControlName="strPersonnelID" [disabled]="isLoading">

        </div>

        <!-- زمان شروع ذخیره اطلاعات ردیاب -->

        <div class="position-relative clockpicker col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> زمان شروع ذخیره اطلاعات ردیاب </label>

            <input type="text" class="form-control text-center bg-light text-center"

                formControlName="strStartTime" id="startTime" readonly>
                
        </div>
        
        <!-- زمان پایان ذخیره اطلاعات ردیاب -->

        <div class="position-relative clockpicker col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> زمان پایان ذخیره اطلاعات ردیاب </label>

            <input type="text" class="form-control text-center bg-light text-center"

                formControlName="strEndTime" id="endTime" readonly>
                
        </div>

        <!-- نوع پلاک -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع پلاک </label>

            <select class="form-select" formControlName="tiPlateType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Plate" value="{{item.tiPlateType}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- پلاک خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> پلاک </label>

            <div class="border border-1 d-flex flex-wrap">

                <div class="col-md-2 col-3 ">

                    <input type="text" placeholder="ایران"

                        class="w-100 bg-light border-0 border-end text-center form-control"
                        
                        [maxLength]="2"

                        (keypress)="checkNum($event)"
                        
                        formControlName="Plak4">
                </div>

                <div class="col-3">

                    <input type="text" 
                    
                        class="w-100 bg-light border-0 text-center form-control border-start"

                        placeholder="_ _ _"
                        
                        [maxLength]="3"
                        
                        (keypress)="checkNum($event)" formControlName="Plak3">

                </div>

                <select class="col-lg-3 col-2 bg-light border-0 text-center" formControlName="Plak2">

                    <option value="الف">الف</option>
                    <option value="ب">ب</option>
                    <option value="پ">پ</option>
                    <option value="ت">ت</option>
                    <option value="ج">ج</option>
                    <option value="د">د</option>
                    <option value="س">س</option>
                    <option value="ص">ص</option>
                    <option value="ط">ط</option>
                    <option value="ق">ق</option>
                    <option value="ع">ع</option>
                    <option value="ک">ک</option>
                    <option value="ل">ل</option>
                    <option value="م">م</option>
                    <option value="ن">ن</option>
                    <option value="و">و</option>
                    <option value="ه">ه</option>
                    <option value="ی">ی</option>
                </select>

                <div class="col-3">

                    <input type="text" 
                    
                        class="w-100 bg-light border-0 text-center form-control" 
                        
                        placeholder="_ _"

                        [maxLength]="2"
                        
                        (keypress)="checkNum($event)"
                        
                        formControlName="Plak1">
                </div>

            </div>

        </div>

        <!-- فعال -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bActive" formControlName="bActive">
        
            <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>
        
        </div>

        <!-- سیپاد -->

        <div *ngIf="acssess?.bSetSeepad && Id != 3" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bSeepad" formControlName="bSeepad">
        
            <label class="form-check-label pointer text-muted me-2" for="bSeepad"> سیپاد </label>
        
        </div>

        <!-- اداری -->

        <div *ngIf="acssess?.bPeysepar" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bOfficial" formControlName="bOfficial">
        
            <label class="form-check-label pointer text-muted me-2" for="bOfficial"> اداری </label>
        
        </div>

        <!-- تانکر -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bTanker" formControlName="bTanker">
        
            <label class="form-check-label pointer text-muted me-2" for="bTanker"> تانکر </label>
        
        </div>

        <!-- کنترل سوخت -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bFuelSensor" formControlName="bFuelSensor">
        
            <label class="form-check-label pointer text-muted me-2" for="bFuelSensor"> کنترل سوخت </label>
        
        </div>

        <!-- دش کم -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bDashCam" formControlName="bDashCam">
        
            <label class="form-check-label pointer text-muted me-2" for="bDashCam"> دش کم </label>
        
        </div>
        
        <!-- سنسور وزن -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bWeightSensor" formControlName="bWeightSensor">
        
            <label class="form-check-label pointer text-muted me-2" for="bWeightSensor"> سنسور وزن </label>
        
        </div>
        
        <!-- سنسور دما -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bTemperatureSensor" formControlName="bTemperatureSensor">
        
            <label class="form-check-label pointer text-muted me-2" for="bTemperatureSensor"> سنسور دما </label>
        
        </div>

        <!-- اتصال به ECU  -->

        <div *ngIf="Id == 1 || sabtModelGps.get('bHasGPS').value" class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bOBD2" formControlName="bOBD2">
        
            <label class="form-check-label pointer text-muted me-2" for="bOBD2"> اتصال به ECU  </label>
        
        </div>

        <!-- فلومتر  -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bFlowmeter" formControlName="bFlowmeter">
        
            <label class="form-check-label pointer text-muted me-2" for="bFlowmeter"> فلومتر  </label>
        
        </div>

        <!-- توضیحات -->

        <div class="position-relative col-12 p-2">

            <label class="mb-2 text-muted"> توضیحات </label>

            <textarea style="height: 70px;resize: none;" class="form-control" formControlName="strComment"></textarea>

        </div>

        <!-- دکمه های فرم -->

        <div class="position-relative col-12 p-2">

            <!-- ثبت -->

            <ng-container *ngIf="!editMod">

                <button class="btn btn-success col-12 col-md-auto" (click)="sabtGps()" [disabled]="isLoading">

                    &nbsp; ثبت &nbsp;
            
                </button>

            </ng-container>

            <!-- ویرایش -->

            <ng-container *ngIf="editMod">

                <button class="btn btn-warning col-12 me-md-2 col-md-auto"  (click)="sabtGps()">
    
                    ویرایش
            
                </button>

                <button class="btn btn-secondary col-12 col-md-auto" (click)="openGreenPaper_Modal()">
    
                    برگ سبز خودرو  
            
                </button>

            </ng-container>

            <!-- خودرو اداری -->

            <ng-container *ngIf="singelCar?.bOfficial && editMod">

                <button class="btn btn-outline-primary mx-md-2 my-2 my-md-0 col-12 col-md-auto" [disabled]="isLoading" (click)="mobile_OfficialStatus()">

                    تغییر وضعیت

                </button>

                <button class="btn btn-outline-success col-12 col-md-auto" [disabled]="isLoading" (click)="additionalInfo()">

                    اطلاعات تکمیلی

                </button>

            </ng-container>

            <!-- تعرفه خدمات -->

            <ng-container *ngIf="editMod && acssess.bTariff">

                <button class="btn btn-primary mx-md-2 my-2 my-md-0 col-12 col-md-auto"  data-bs-toggle="modal" data-bs-target="#tariff">
    
                     تعرفه خدمات
    
                </button>

            </ng-container>

            <!-- کاربری ورودی ها -->

            <ng-container *ngIf="editMod && acssess.bIOUsage">

                <button class="btn btn-success col-12 col-md-auto" data-bs-toggle="modal" data-bs-target="#workly-gps-modal">
        
                    کاربری ورودی ها
        
                </button>

            </ng-container>

            <!-- حذف -->

            <ng-container *ngIf="editMod && acssess.bDeleteCar">

                <button class="btn btn-danger mx-md-2 my-2 my-md-0 col-12 col-md-auto"  (click)="deleteCar()">
    
                    حذف
            
                </button>

            </ng-container>

            <!-- خروج -->

            <ng-container *ngIf="singelCar && singelCar.bIncomplete">

                <button class="btn btn-danger col-12 col-md-auto"  (click)="exit()">
    
                    خروج
            
                </button>

            </ng-container>

        </div>

    </div>

    <!-- ثبت خودرو بدون GPS -->

    <div *ngIf="Id == 2" [formGroup]="sabtModel" class="container-fluid row gx-2 gy-md-1 gy-2 p-2">

        <!-- نوع پلاک -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع پلاک </label>

            <select class="form-select" formControlName="tiPlateType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_Plate" value="{{item.tiPlateType}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- پلاک خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> پلاک </label>

            <div class="border border-1 d-flex flex-wrap">

                <div class="col-md-2 col-3 ">

                    <input type="text" placeholder="ایران"

                        class="w-100 bg-light border-0 border-end text-center form-control"
                        
                        [maxLength]="2"

                        (keypress)="checkNum($event)"
                        
                        formControlName="Plak4">
                </div>

                <div class="col-3">

                    <input type="text" 
                    
                        class="w-100 bg-light border-0 text-center form-control border-start"

                        placeholder="_ _ _"
                        
                        [maxLength]="3"
                        
                        (keypress)="checkNum($event)" formControlName="Plak3">

                </div>

                <select class="col-lg-3 col-2 bg-light border-0 text-center" formControlName="Plak2">

                    <option value="الف">الف</option>
                    <option value="ب">ب</option>
                    <option value="پ">پ</option>
                    <option value="ت">ت</option>
                    <option value="ج">ج</option>
                    <option value="د">د</option>
                    <option value="س">س</option>
                    <option value="ص">ص</option>
                    <option value="ط">ط</option>
                    <option value="ق">ق</option>
                    <option value="ع">ع</option>
                    <option value="ک">ک</option>
                    <option value="ل">ل</option>
                    <option value="م">م</option>
                    <option value="ن">ن</option>
                    <option value="و">و</option>
                    <option value="ه">ه</option>
                    <option value="ی">ی</option>
                </select>

                <div class="col-3">

                    <input type="text" 
                    
                        class="w-100 bg-light border-0 text-center form-control" 
                        
                        placeholder="_ _"

                        [maxLength]="2"
                        
                        (keypress)="checkNum($event)"
                        
                        formControlName="Plak1">
                </div>

            </div>

        </div>

        <!-- نوع کاربری -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع کاربری </label>

            <select class="form-select" formControlName="tiMobileUsage">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_MobileUsage" value="{{item.tiMobileUsage}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- نوع خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع خودرو </label>

            <select class="form-select" formControlName="tiMobileType">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of carWork" value="{{item.tiMobileType}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- گروه خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> گروه خودرو </label>

            <select class="form-select" formControlName="tiMobileGroup">

                <option class="text-center" [value]="-1"> انتخاب کنید </option>

                <option class="text-center" *ngFor="let item of lst_GroupCar" value="{{item.tiMobileGroup}}">

                    {{item.strComment}}

                </option>

            </select>

        </div>

        <!-- نام خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نام خودرو </label>

            <input type="text"

                [placeholder]="carType.length == 0 && searchT_CarName == '' ?
                
                ' لطفا اندکی صبر کنید ' : 'جستجو کنید ...'  "

                name="selectedCarName" autocomplete="off" class="form-control text-center"
                
                (focus)="filteredCarName = carType"

                [(ngModel)]="searchT_CarName" 
                
                [ngModelOptions]="{standalone: true}"
                
                (input)="filterCarName()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" 
                
                *ngFor="let item of filteredCarName" [@fadeAnimation]

                    (click)="selectedCarName(item)"> {{item.strComment }}
                
                </li>

            </ul>

        </div>

        <!-- تیپ خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> تیپ خودرو </label>

            <input class="form-control p-2 text-center" formControlName="strVehicleType">

        </div>

        <!-- کد خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> کد خودرو </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="iCode">

        </div>

        <!-- ظرفیت خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> ظرفیت خودرو </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="tiPassenger">

        </div>

        <!-- نوع سوخت -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> نوع سوخت </label>

            <select class="form-select" formControlName="tiFuelType">

                <option class="text-center" [value]="0"> ندارد</option>

                <option class="text-center" [value]="1"> بنزین </option>

                <option class="text-center" [value]="2"> نفت گاز </option>

                <option class="text-center" [value]="3"> هیبرید </option>

                <option class="text-center" [value]="4"> برقی </option>

            </select>

        </div>

        <!-- ظرفیت باک (لیتر)  -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> ظرفیت باک (لیتر)  </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1').replace(/^(\d*\.\d{1}).*$/, '$1');"
            
                formControlName="fFuelTankCapacity">

        </div>

        <!-- آیکون خودرو -->

        <div class="col-12 col-md-4 position-relative p-2">

            <label class="mb-2 text-muted"> آیکون خودرو </label>

            <input type="text"

                [placeholder]="carImg.length == 0 && searchT_CarIcon == '' ?
                
                ' لطفا اندکی صبر کنید ' : 'جستجو کنید ...'  "

                name="selectedCarIcon" autocomplete="off" class="form-control text-center"
                
                (focus)="filteredCarIcon = carImg"

                [(ngModel)]="searchT_CarIcon"
                
                [ngModelOptions]="{standalone: true}" (input)="filterCarIcon()" />

            <ul class="list-group" style="max-height: 200px;overflow: auto;">

                <li class="list-group-item pointer" 
                
                *ngFor="let item of filteredCarIcon" [@fadeAnimation]

                    (click)="selectedCarIcon(item,item.tiMobileIcon)"> 
                    
                    <img src="data:image/jpeg;base64,{{item.strMobileIcon}}">
                    
                    {{item.strComment}} 
                
                </li>

            </ul>

        </div>

        <!-- سال ساخت -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> سال ساخت </label>

            <input type="text" class="form-control text-center"  formControlName="iYearConstruction">

        </div>

        <!-- موبایل مالک / راننده -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> موبایل مالک / راننده </label>

            <input class="form-control p-2 text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="strMobile">

        </div>

        <!-- مالک / راننده -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> مالک / راننده </label>

            <input class="form-control p-2 text-center"

                formControlName="strFullName">

        </div>

        <!-- رمز عبور کاربر -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> رمز عبور کاربر </label>

            <input type="text" class="form-control text-center"  formControlName="strPassword">
            
        </div>

        <!-- کیلومتر فعلی (km) -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> کیلومتر فعلی (km) </label>

            <input type="text" class="form-control text-center"

                oninput="this.value = this.value.replace(/[^0-9]/g,'')"
            
                formControlName="fLastKM">
            
        </div>

        <!-- رنگ خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> رنگ خودرو </label>

            <input type="text" class="form-control text-center"  formControlName="strColor">

        </div>

        <!-- vin خودرو -->

        <div class="position-relative col-12 col-md-4 p-2">

            <label class="mb-2 text-muted"> VIN خودرو </label>

            <input type="text" class="form-control text-center"  formControlName="strVIN">

        </div>

        <!-- فعال -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bActive" formControlName="bActive">
        
            <label class="form-check-label pointer text-muted me-2" for="bActive"> فعال </label>
        
        </div>

        <!-- اداری -->

        <div class="form-check form-switch m-0 d-flex align-items-center col-12 col-md-auto p-2">

            <input class="form-check-input m-0" type="checkbox" id="bOfficial" formControlName="bOfficial">
        
            <label class="form-check-label pointer text-muted me-2" for="bOfficial"> اداری </label>
        
        </div>

        <!-- توضیحات -->

        <div class="position-relative col-12 p-2">

            <label class="mb-2 text-muted"> توضیحات </label>

            <textarea style="height: 70px;resize: none;" class="form-control" formControlName="strComment"></textarea>

        </div>

        <!-- دکمه های فرم -->

        <div class="position-relative col-12 p-2">

            <!-- ثبت -->

            <ng-container *ngIf="!editMod">

                <button class="btn btn-success col-12 col-md-auto" (click)="sabt()">

                    &nbsp; ثبت &nbsp;
            
                </button>

            </ng-container>

            <!-- ویرایش -->

            <ng-container *ngIf="editMod">

                <button class="btn btn-warning col-12 me-md-2 col-md-auto"  (click)="sabt()">
    
                    ویرایش
            
                </button>

                <button class="btn btn-secondary col-12 col-md-auto" (click)="openGreenPaper_Modal()">
    
                    برگ سبز خودرو  
            
                </button>

            </ng-container>

            <!-- حذف -->

            <ng-container *ngIf="editMod && acssess.bDeleteCar">

                <button class="btn btn-danger mx-md-2 my-2 my-md-0 col-12 col-md-auto"  (click)="deleteCar()">
    
                    حذف
            
                </button>

            </ng-container>

        </div>

    </div>

</main>

<!--تعرفه خدمات-->

<div class="modal fade" id="tariff" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog ">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id=" ">تعرفه خدمات</h5>
                <button type="button " class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex flex-column dirI " [formGroup]="saveTariff">
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ ساعتی (ریال) :</label>
                    </div>
                    <div class=" col-6 ">
                        <input class="form-control" type="number" formControlName="iHourlyRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ اضافه کاری (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iOvertimeRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ کیلومتر داخل شهر (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iUrbanOperationRates">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ کیلومتر ماموریت (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iNonurbanOperatingRates">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>نرخ توقف شبانه (ریال) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control" type="number" formControlName="iOvernightStopRate">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>اضافه کار تشویقی (ساعت) :</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control " type="number" type="number" formControlName="iIncentiveOvertime">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>پیمایش تشویقی(Km):</label>
                    </div>
                    <div class=" col-6 mt-2">
                        <input class="form-control " type="number" type="number" formControlName="iIncentiveKm">
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>ساعت شروع کار:</label>
                    </div>
                    <div class=" col-6 mt-2 clockpicker">
                        <input type="text" class="form-control shadow bg-light" id="Stime"
                            formControlName="strStartTime">
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>
                </div>
                <div class="col-12 d-flex flex-row">
                    <div class="col-6 d-flex align-items-center">
                        <label>ساعت پایان کار:</label>
                    </div>
                    <div class=" col-6 mt-2 clockpicker">
                        <input type="text" class="form-control shadow bg-light" formControlName="strEndTime" id="Etime">
                        <span class="input-group-addon">
                            <span class="glyphicon glyphicon-time"></span>
                        </span>
                    </div>
                </div>
            </div>
            <div class="modal-footer ">

                <button type="button " class="btn btn-primary" (click)="editTariff()">ویرایش</button>
            </div>
        </div>
    </div>
</div>

<!-- کاربری ورودی ها -->

<div class="modal fade" id="workly-gps-modal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">کاربری ورودی ها</h5>
                <button type="button " class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <div class="modal-body ">
                <div class="d-flex flex-wrap dirI justify-content-around align-items-end" [formGroup]="worklyForm">
                    <div class="col-md-4 col-5">
                        <label>ورودی </label>
                        <select class="form-select" formControlName="strIOTitle">
                            <option value="-1">انتخاب کنید</option>
                            <option *ngFor="let item of iOTitle" value="{{item.strIOTitle}}">{{item.strIOTitle}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-4 col-5">
                        <label>کاربری ورودی </label>
                        <select class="form-select" formControlName="iIOUsage">
                            <option value="-1">انتخاب کنید</option>
                            <option *ngFor="let item of IOUsage" value="{{item.iIOUsage}}">{{item.strComment}}</option>

                        </select>
                    </div>
                    <div class="col-md-2 col-4 mt-2 mt-md-0">
                        <button class="btn btn-primary" (click)="addWorkly()">اضافه کردن</button>
                    </div>
                </div>
                <hr>
                <div>
                    <table class="table table-striped border border-2 rounded-3 dirI">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th class="text-center">عملیات</th>
                                <th class="text-center">ورودی</th>
                                <th class="text-center">کاربری</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of worklyData; let i=index">
                                <td class="dirl f22 text-center pointer">

                                    <i class="fa fa-trash text-danger mx-1" title="حذف"
                                        (click)="deleteIo(item.iIOMobileUsage)"></i>
                                    <i class="fa fa-edit text-warning mx-1" title="عنوان متناظر با مقدار ورودی"
                                        data-bs-toggle="modal" data-bs-target="#iOValueTitleModal"
                                        (click)="getEditIo(item.iIOMobileUsage)"></i>

                                </td>

                                <td class="text-center ">{{item.strIOTitle}}</td>
                                <td class="text-center "> {{item.strIOUsage_strComment}}</td>
                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- عنوان متناظر با مقدار ورودی -->

<div class="modal fade" id="iOValueTitleModal" tabindex="-1" aria-labelledby="" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header dirI">
                <h5 class="modal-title" id="">عنوان متناظر با مقدار ورودی </h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body d-flex flex-wrap">
                <div class="col-12 d-flex flex-row dirI mt-1">

                    <table class="table table-striped border border-2 rounded-3 ">
                        <thead>
                            <!-- [ngClass]="showLocation  ? 'index-1' : ''" -->
                            <tr class="">
                                <th class="text-center">مقدار ورودی</th>
                                <th class="text-center">عنوان متناظر</th>
                                <th class="text-center">ویرایش عنوان</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="" *ngFor="let item of editIoData; let i=index">
                                <td class="text-center">{{item.strValue}}</td>
                                <td class="text-center "><input class="form-control" type="text"
                                        value="{{item.strValueTitle}}" id="value{{item.strValue}}"></td>
                                <td class="text-center"><i class="fa fa-edit text-warning fa-2x pointer"
                                        (click)="EditIOValueTitle(item)"></i></td>

                            </tr>

                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer dirI">
                <button type="button" class="btn btn-primary" data-bs-toggle="modal"
                    data-bs-target="#workly-gps-modal">برگشت</button>
            </div>
        </div>
    </div>
</div>

<!-- اطلاعات تکمیلی -->

<div class="modal fade" id="additionalInfoModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> اطلاعات تکمیلی </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_AdditionalInfo" class="container-fluid row gx-2 gy-2 p-2">

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره پرسنلی راننده </label>

                        <input class="form-control p-2 text-center" formControlName="strPersonnelID">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> نوع خدمات سفر </label>

                        <select class="form-select" formControlName="tiAppUsages">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lst_AppUsage" [value]="item.tiAppUsages">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> حوزه خدمت </label>

                        <select class="form-select" formControlName="iMobileDomain">

                            <option class="text-center" [value]="-1"> انتخاب کنید </option>

                            <option class="text-center" *ngFor="let item of lst_MobileDomain"
                                [value]="item.iMobileDomain">

                                {{item.strComment}}

                            </option>

                        </select>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> کد شناسایی </label>

                        <input class="form-control p-2 text-center" formControlName="iCode">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره حساب </label>

                        <input class="form-control p-2 text-center" formControlName="strBankAccount"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> فاصله زمانی ارسال اطلاعات (ثانیه) </label>

                        <input class="form-control p-2 text-center" formControlName="iPeriodSendingLoc"
                            oninput="this.value = this.value.replace(/[^0-9]/g,'')">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> فاصله مکانی ارسال اطلاعات (متر) </label>

                        <input class="form-control p-2 text-center" formControlName="iLocationCourseSending">

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2 clockpicker">

                        <label class="mb-2 text-muted"> ساعت شروع فعالیت </label>

                        <input class="form-control p-2 text-center" formControlName="strStartTime" id="aStartTime"
                            readonly>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2 clockpicker">

                        <label class="mb-2 text-muted"> ساعت پایان فعالیت </label>

                        <input class="form-control p-2 text-center" formControlName="strEndTime" id="aEndTime" readonly>

                    </div>

                    <div class="position-relative col-12 col-md-4 p-2">

                        <label class="mb-2 text-muted"> شماره موبایل مرکز </label>

                        <input class="form-control p-2 text-center" formControlName="strManagerMobile">

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bEnableTimer" formControlName="bEnableTimer">

                        <label class="form-check-label pointer text-muted me-2" for="bEnableTimer"> تایمر دریافت اطلاعات از سرور  </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bCheckPosition" formControlName="bCheckPosition4Ready">

                        <label class="form-check-label pointer text-muted me-2" for="bCheckPosition"> کنترل موقعیت راننده </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bHastrafficLoc" formControlName="bHastrafficLoc">

                        <label class="form-check-label pointer text-muted me-2" for="bHastrafficLoc"> طرح ترافیک </label>

                    </div>

                    <div class="form-check form-switch m-0 d-flex align-items-center col-12 p-2">

                        <input class="form-check-input m-0" type="checkbox" id="bHasEvenoddb" formControlName="bHasEvenoddb">

                        <label class="form-check-label pointer text-muted me-2" for="bHasEvenoddb"> طرح کنترل آلودگی هوا </label>

                    </div>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="editAdditionalInfo()">

                    &nbsp; &nbsp; ویرایش &nbsp; &nbsp;

                </button>

                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- تغییر وضعیت -->

<div class="modal fade" id="officialStatus_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog">

        <div class="modal-content dirI">

            <div class="modal-header">

                <h5 class="modal-title" id="exampleModalLabel"> تغییر وضعیت سفر </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_AdditionalInfo" class="position-relative col-auto p-2">

                    <label class="mb-2 text-muted"> وضعیت </label>

                    <select class="form-select" formControlName="tiOfficialStatus">

                        <option class="text-center" [value]="-1"> انتخاب کنید </option>

                        <option class="text-center" *ngFor="let item of lst_OfficialStatus" [value]="item.tiOfficialStatus">

                            {{item.strComment}}

                        </option>

                    </select>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-primary" (click)="editOfficialStatus()">

                    &nbsp; &nbsp; ویرایش &nbsp; &nbsp;

                </button>

                
                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>

<!-- برگ سبز خودرو -->

<div class="modal fade" id="greenPaper_Modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-xl">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> اطلاعات برگ سبز خودرو </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div [formGroup]="mdl_GreenPaper" class="row gx-2 gy-2 p-2">

                    <!-- تعداد سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiCylinders"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد محور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد محور </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiAxis"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- تعداد چرخ -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تعداد چرخ </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="tiWheels"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره موتور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره موتور </label>
            
                        <input formControlName="strEngineNumber" class="form-control p-2 text-center">
            
                    </div>

                    <!-- شماره شاسی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره شاسی </label>
            
                        <input formControlName="strChassisNumber" class="form-control p-2 text-center">
            
                    </div>
                    
                    <!-- حجم سیلندر -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> حجم سیلندر </label>
            
                        <input oninput="this.value = this.value.replace(/[^0-9]/g,'')"

                            formControlName="iCylinderVolume"
                        
                            class="form-control p-2 text-center">
            
                    </div>

                    <!-- نام و نام خانوادگی مالک  -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> نام و نام خانوادگی مالک  </label>
            
                        <input formControlName="strOwnerFullName" class="form-control p-2 text-center">
            
                    </div>

                    <!-- نام پدر  -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> نام پدر  </label>
            
                        <input formControlName="strOwnerFatherName" class="form-control p-2 text-center">
            
                    </div>

                    <!-- تاریخ تولد -->
            
                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> تاریخ تولد </label>
            
                        <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"

                            [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">
            
                            <input formControlName="strOwnerBirthDate" class="form-control text-center" />
            
                        </ng-persian-datepicker>
            
                    </div>

                    <!-- شماره شناسنامه -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره شناسنامه </label>
            
                        <input formControlName="strOwnerCertificateNumber" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- شماره ملی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> شماره ملی </label>
            
                        <input formControlName="strOwnerNationalCode" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- محل صدور -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> محل صدور </label>
            
                        <input formControlName="strOwnerPlaceIssue" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- کد پستی -->

                    <div class="position-relative col-12 col-md-3 p-2">
            
                        <label class="mb-2 text-muted"> کد پستی </label>
            
                        <input formControlName="strOwnerPostalCode" class="form-control p-2 text-center">
            
                    </div>
            
                    <!-- آدرس -->

                    <div class="position-relative col-12 p-2">

                        <label class="mb-2 text-muted"> آدرس </label>
            
                        <textarea formControlName="strOwnerAdress" style="height: 100px;resize: none;" class="form-control"></textarea>
            
                    </div>
            
                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-success" (click)="submit_GreenPaper()">

                    &nbsp; &nbsp; ثبت &nbsp; &nbsp;

                </button>

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>
